import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PackedOnItemReferenceService extends BaseReferenceService {
  constructor() {
    super('PackedOnItemReference');
  }
}
